module.exports = __webpack_public_path__ + "img/ics_o_sort_active.80daf614.svg";